export const convertOfficialDetailsToSignerDetails = (officialDetails) => {
  return {
    name: officialDetails.names.firstName
      ? officialDetails.names.firstName + " " + officialDetails.names.lastName
      : officialDetails.names.companyName
      ? officialDetails.names.companyName
      : officialDetails.electronicAddress.emailAddress,
    emailAddress: officialDetails.electronicAddress.emailAddress,
    // electronicAddress: officialDetails.electronicAddress,
  };
};

// get e-signature email link for the logged-in user
export const getEsignatureEmailLink = (currentUser, eSignatureEmailLinks) => {
  const emailLink = eSignatureEmailLinks.find(
    (link) => link.email === currentUser?.electronicAddress?.emailAddress
  );
  return emailLink ? emailLink.eSignatureLink : null;
};
